var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.BButton,{staticClass:"btn-icon rounded-circle",style:({
      backgroundColor: _setup.props.value + '!important'
    }),on:{"click":_setup.openColorPicker}},[_c('feather-icon',{attrs:{"icon":"Edit3Icon"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }